import React from 'react';
import { Loader } from './LogoLoader.styles';

const LogoLoader = ({ className, width, height }) => {
  return <Loader className={className} $width={width} $height={height} />;
};

export default LogoLoader;
